import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
  useErrorService,
  useUserService,
  AssessmentLoader,
} from '@abroad/components'
import { FreePlanNoSurvey, PageHeader } from '../components'
import API from '../utils/API'
import { surveyType } from '../utils/constants'
import { sortedByDate } from '../utils/date'

const type = 'personal'

const renderHelmet = () => {
  return (
    <Helmet>
      <title>{'Awareness Assessment | Abroad'}</title>
      <meta name='title' content={'Awareness Assessment | Abroad'}></meta>
      <meta
        property='og:title'
        content={'Awareness Assessment | Abroad'}></meta>
      <meta
        property='twitter:title'
        content={'Awareness Assessment | Abroad'}></meta>
      <link
        rel='canonical'
        href={`${process.env.REACT_APP_DOMAIN}/survey`}></link>
      <meta
        property='og:url'
        content={`${process.env.REACT_APP_DOMAIN}/survey`}></meta>
      <meta
        property='twitter:url'
        content={`${process.env.REACT_APP_DOMAIN}/survey`}></meta>
    </Helmet>
  )
}
const renderPageHeader = () => (
  <PageHeader title='Awareness Assessment' wrapperClasses='mb-32px' />
)

const NoAwarenessAssessment = () => {
  const [isLoading, setIsLoading] = useState(true)
  const Error = useErrorService()
  const { user } = useUserService()
  const history = useHistory()

  useEffect(() => {
    let isActive = true // Prevent stale async redirect after leaving /survey for quest participation is true

    const getSurveys = async () => {
      try {
        const { data } = await API.survey.getSurveys(type, surveyType.AWARENESS) // (surveyType, filterBy)
        if (!isActive) return
        if (data && data?.surveys.length > 0) {
          const sortedSurveys = sortedByDate(data?.surveys, 'createdAt') // (data, key)
          history.push(`/survey/${sortedSurveys[0]?._id}`)
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      } catch (e) {
        if (!isActive) return
        Error.showError(e)
        setIsLoading(false)
      }
    }
    if (user?.surveyTaken) {
      getSurveys()
    } else {
      setIsLoading(false)
    }
    return () => {
      isActive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {renderHelmet()}
      <main>
        {renderPageHeader()}
        {isLoading ? (
          <AssessmentLoader />
        ) : (
          <FreePlanNoSurvey isRenderOnAwarenessPage={true} />
        )}
      </main>
    </>
  )
}

export default NoAwarenessAssessment
